<div class="flex items-center gap-4">
  <!-- Preview -->
  <div
    class="relative flex h-20 w-20 shrink-0 items-center justify-center overflow-hidden border border-greyscale-200 bg-greyscale-100"
    [class.rounded-full]="shape === 'round'"
    [class.rounded-lg]="shape === 'square'"
  >
    @if (localPreviewUrl() ?? currentLogoUrl) {
      <img
        [src]="localPreviewUrl() ?? currentLogoUrl"
        alt="logo"
        class="h-full w-full object-cover"
      />
    } @else {
      <i class="pi pi-image text-2xl text-greyscale-400"></i>
    }

    @if (uploading) {
      <div
        class="absolute inset-0 flex items-center justify-center bg-white/70"
      >
        <p-progressSpinner
          strokeWidth="4"
          [style]="{ width: '2rem', height: '2rem' }"
        />
      </div>
    }
  </div>

  <!-- Choose file -->
  <div class="flex flex-col gap-1">
    <p-fileupload
      #fileUpload
      name="image"
      [accept]="config.accept"
      [maxFileSize]="config.maxSize"
      (onSelect)="onFileSelect($event)"
      [showUploadButton]="false"
      [showCancelButton]="false"
      mode="basic"
      chooseIcon="pi pi-upload"
      [auto]="true"
      [disabled]="uploading"
      [chooseLabel]="'logoUpload.choose' | transloco"
      chooseStyleClass="!bg-primary-50 !text-primary-500 !border !border-primary-500 hover:!bg-primary-100"
    />
    <span class="text-xs text-greyscale-500">
      {{ "logoUpload.hint" | transloco: { size: config.maxSizeMB } }}
    </span>
  </div>
</div>

<!-- Crop dialog -->
<p-dialog
  [modal]="true"
  appendTo="body"
  [(visible)]="cropDialogVisible"
  [style]="{ width: '40rem', maxWidth: '95vw' }"
  [closable]="false"
  [header]="'logoUpload.cropTitle' | transloco"
>
  @if (selectedFile()) {
    <image-cropper
      [imageFile]="selectedFile()"
      [maintainAspectRatio]="true"
      [aspectRatio]="aspectRatio"
      [roundCropper]="shape === 'round'"
      [resizeToWidth]="512"
      format="png"
      output="blob"
      (imageCropped)="onImageCropped($event)"
    />
  }
  <div class="mt-4 flex justify-end gap-2">
    <p-button
      [label]="'logoUpload.cancel' | transloco"
      severity="secondary"
      (click)="cancelCrop()"
    />
    <p-button
      [label]="'logoUpload.apply' | transloco"
      (click)="confirmCrop()"
    />
  </div>
</p-dialog>
